<template>
    <div class="blank">
        <group gutter="8" type="hint">
            <cell height="64">
                <div slot="title">
                    <img class="icon" src="../assets/images/question.png" height="22" width="21" alt="">
                </div>
                <p class="value help-detail-title" slot="value">{{title}}</p>
            </cell>
        </group>
        <div class="help-answer">
            <div class="help-icon">
                <img class="icon" src="../assets/images/ask.png" height="22" width="21" alt="">
            </div>
            <div class="help-detail" v-html="detail">
            </div>
        </div>
    </div>
</template>
<style lang="sass">
@import '../assets/styles/all.scss';

.blank {
    background-color: #F6F6F6;
    .value.help-detail-title {
        white-space: pre-wrap;
    }
}
.icon {
    display: inline-block;
    vertical-align: middle;
}
.value {
    font-size: 15px;
    font-weight: 500;
    color: #000;
}
.help-answer {
    position: relative;
    margin-top: r(8);
    background-color: #fff;
    padding-left: r(16);
    min-height: r(55);
    .help-icon {
        position: absolute;
        width: r(20);
        padding-right: r(15);
        line-height: r(55);
    }
    .help-detail {
        position: relative;
        margin-left: r(36);
        padding: r(17) r(15) r(17) 0;
        color: #999;
    }
}
</style>
<script>
    import {
        Group,
        Cell
    } from 'fiui'
    // import { listItem, list } from '../utils/faq.js'
    import storage from '../utils/storage'

    export default {
        components: {
            Group,
            Cell
        },
        data () {
            return {
                title: '',
                detail: ''
            }
        },
        created () {
            let titleContent = storage.get('titleContent')
            this.title = titleContent.title
            this.detail = titleContent.context
        },
        beforeRouteEnter (to, from, next) {
            document.title = '帮助中心'
            next()
        },
    }
</script>



// WEBPACK FOOTER //
// helpdetail.vue?3b93e369